<template>

	<div>
		{{ test }}

	<line-component
		:height="height"
		:chart-data="data"
		:chart-options="options"
	/>

	</div>


</template>

<script>

import { Line as LineComponent } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	LineElement,
	PointElement,
	CategoryScale,
	LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, ChartDataLabels)


export default {

	props: {

		test: {
			type: String,
		},

		height: {
			type: Number,
			default: 300
		},

		chartData: {
			type: Object,
			default: () => { }
		},

		options: {
			type: Object,
			default: () => { }
		}

	},

	data() {
		return {
			data: {}
		}
	},

	components: {
		LineComponent,
	},

	mounted() {
		if(this.chartData) {
			this.data = this.chartData
		}

		window.livewire.on("lineChartUpdated", data => {
			this.data = data
		})
	}

}

</script>
